<template>
  <el-dialog
    :title="Baslik"
    :visible="ModalOlayi"
    v-if="Baslik"
    center
    width="60%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>

    <el-collapse>
      <el-collapse-item title="Hesap Bilgi">
        <table class="table table-bordered">
          <tbody>
          <tr>
            <td>
              <small>Ünvan</small>
              {{ Detay.Unvan }}
            </td>
            <td>
              <small>Telefon</small>
              {{ Detay.Telefon }}
            </td>
            <td>
              <small>E-Posta</small>
              {{ Detay.EMail }}
            </td>
            <td>
              <small>Şehir</small>
              {{ Detay.Sehir }}
            </td>
          </tr>
          <tr>
            <td>
              <small>Vergi Dairesi</small>
              {{ Detay.vDaire }}
            </td>
            <td>
              <small>Vergi No</small>
              {{ Detay.vNo }}
            </td>
            <td colspan="2">
              <small>Adres</small>
              {{ Detay.Adres }}
            </td>
          </tr>
          <tr>
            <td>
              <small>Giriş Kısıtlama</small>
              {{ Diger.Giris }}
            </td>
            <td>
              <small>Giriş Maili</small>
              {{ Diger.GirisMail }}
            </td>
            <td>
              <small>Sistem Açılış/Kapanış Saati</small>
              {{ Diger.aSaat }} - {{ Diger.kSaat }}
            </td>
            <td>
              <small>NVI Api</small>
              {{ Diger.TCKimlik }}
            </td>
          </tr>
          <tr>
            <td>
              <small>Destek İzni</small>
              {{ Diger.Destek }}
            </td>
            <td>
              <small>Sms Gönderim Aralığı</small>
              {{ Diger.SmsSure }} DK
            </td>
            <td>
              <small>Telegram ID</small>
              {{ Diger.Telegram }}
            </td>
            <td>
              <small>Private Key</small>
              {{ Diger.PrivateKey }}
            </td>
          </tr>
          </tbody>
        </table>
      </el-collapse-item>
      <el-collapse-item title="Kullanım Detayları">
        <table class="table table-hover">
          <thead>
          <tr>
            <th colspan="4">Kullanım Detayları <b class="float-right">Kayıt Zamanı: {{ HizmetBilgi.Tarih }}</b></th>
          </tr>
          <tr>
            <th>Hizmet</th>
            <th class="text-right">Satın Alınan</th>
            <th class="text-right">Sarfiyat</th>
            <th class="text-right">Bakiye</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Mesken</td>
            <td class="text-right">{{ HizmetBilgi.Mesken.Alinan }}</td>
            <td class="text-right">{{ HizmetBilgi.Mesken.Sarf }}</td>
            <td class="text-right">{{ HizmetBilgi.Mesken.Kalan }}</td>
          </tr>
          <tr>
            <td>Süre</td>
            <td class="text-right">{{ HizmetBilgi.Sure.Alinan }}</td>
            <td class="text-right">{{ HizmetBilgi.Sure.Sarf }}</td>
            <td class="text-right">{{ HizmetBilgi.Sure.Kalan }}</td>
          </tr>
          </tbody>
        </table>
      </el-collapse-item>
      <el-collapse-item title="Satın Alım Geçmişi">
        <table class="table table-hover table-sm">
          <thead>
          <tr>
            <th colspan="4" class="text-center">Satın Alım Geçmişi</th>
          </tr>
          <tr>
            <th>Tarih</th>
            <th>Ürün</th>
            <th class="text-right">Adet</th>
            <th class="text-right"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="s in SatinAlimlar">
            <td>{{ s.Tarih }}</td>
            <td>{{ s.Baslik }}</td>
            <td class="text-right">{{ s.Adet }}</td>
            <td class="text-right"><a @click="SilOnay(s.Satis_id)" class="text-danger"><b>Sil</b></a></td>
          </tr>
          </tbody>
        </table>
      </el-collapse-item>
      <el-collapse-item title="Satış Ekranı">
        <el-form class="BilgiForm" :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
          <h2>Yeni Satış
            <el-button @click="Submit" size="mini" type="success" class="float-right"
                       style="top:-5px;position: relative">
              Satışı Onayla
            </el-button>
          </h2>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="Ürün" prop="Urun_id">
                <el-select v-model="Form.Urun_id" filterable>
                  <el-option
                    v-for="item in Urunler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Adet" prop="Adet">
                <el-input v-model="Form.Adet"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>

      <el-collapse-item title="Entegrasyon Ekranı">

        <el-form class="BilgiForm">
          <h2>Santral Entegrasyonu
            <el-button @click="SantralGuncelle" size="mini" type="success" class="float-right"
                       style="top:-5px;position: relative">
              Santral Kaydet
            </el-button>
          </h2>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Santral Numarası" prop="Santral">
                <el-input placeholder="8500000000" v-model="Detay.Santral"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h2>Sms Entegrasyonu
            <el-button @click="BaslikGuncelle" size="mini" type="success" class="float-right"
                       style="top:-5px;position: relative"> Sms Kaydet
            </el-button>
          </h2>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="Sms Başlık" prop="SmsBaslik">
                <el-input v-model="Detay.SmsBaslik" max="11"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Api Kullanıcı Adı" prop="SmsKadi">
                <el-input v-model="Detay.SmsKadi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Api Şifre" prop="SmsPass">
                <el-input v-model="Detay.SmsPass"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sms Firması" prop="SmsFirma">
                <el-select v-model="Detay.SmsFirma" filterable>
                  <el-option
                    v-for="item in SmsFirmalari"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </el-dialog>
</template>

<script>
export default {

  props: ["ModalOlayi", "data"],
  data() {
    return {
      Baslik: null,
      Detay: null,
      Diger: null,
      SatinAlimlar: null,
      Form: {
        Urun_id: null,
        Adet: null
      },
      FormHata: {
        Urun_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Adet: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      Urunler: [
        {Adi: 'MESKEN', id: 4},
        {Adi: 'SÜRE (GÜN)', id: 5},
        {Adi: 'SAYAÇ (KREDİ)', id: 7},
        {Adi: 'SMS (KREDİ)', id: 6},
        {Adi: 'MUHASEBE (MUHASEBE MODÜLÜ)', id: 8},
        {Adi: 'SGK (KREDİ)', id: 9},
        {Adi: 'RADİUS (İNTERNET MODÜLÜ)', id: 10},
      ],
      SmsFirmalari: [
        {Adi: 'Movatek', id: 'Movatek'},
        {Adi: '1 Telekom (Sahtekar)', id: '1Telekom'},
      ]
    }
  },
  methods: {
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.UrunSil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    UrunSil(id) {
      this.$store.dispatch("Get", {path: '_a/sil/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.SayfaYukle();
            this.$message.info("Satış Silindi");
          }
        });
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_a/detay/' + this.data})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Detay = response.Detay;
            this.Diger = response.Diger;
            this.HizmetBilgi = response.HizmetBilgi;
            this.SatinAlimlar = response.SatinAlimlar;
            if (this.Detay) this.Baslik = this.Detay.Unvan + " Aidatım Hesap Detayı"
          }
        });
    },
    BaslikGuncelle() {
      this.lo = true;
      this.$store.dispatch("Post", {...this.Detay, path: '_a/smsbaslik/' + this.data})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.$message.success(response.Mesaj);
          }
        });
    },
    SantralGuncelle() {
      this.lo = true;
      this.$store.dispatch("Post", {...this.Detay, path: '_a/santral/' + this.data})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.$message.success(response.Mesaj);
          }
        });
    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: '_a/satis/' + this.data})
            .then(response => {
              this.lo = false;
              if (response.Durum === 'OK') {
                this.Form = {
                  Urun_id: null,
                  Adet: null
                }
                this.$message.success("Satış Tamamlanmıştır");
                this.SayfaYukle();
              }
            });
        }
      });
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>
table small {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/MusteriDetayModal.vue